import dynamic from 'next/dynamic';

import { DataTableSkeleton } from '@kc-console/common-ui';
import { ListLayout, ListSection } from '@kc-console/layout';

import EventsControllerProvider from './EventsControllerProvider';
import EventsHeaderView from './EventsHeaderView';

const EventsContent = dynamic(() => import('./EventsContent'), {
  ssr: false,
  loading: () => <DataTableSkeleton showSideMargin />,
});

/**
 * Status Board 이벤트 내역 페이지 템플릿.
 * @description
 * - 목록 레이아웃에 Breadcrumb, 타이틀, RSS 버튼을 포함한 PageHeader와 이벤트 테이블을 구성한다.
 * @example
 * <EventsTemplate />
 */
const EventsTemplate = () => {
  return (
    <EventsControllerProvider>
      <ListLayout>
        <ListSection headerView={<EventsHeaderView />}>
          <EventsContent />
        </ListSection>
      </ListLayout>
    </EventsControllerProvider>
  );
};

export default EventsTemplate;
